import { useQuery } from 'react-query';
import api from 'config/api';
import { filter, cloneDeep } from 'lodash';
import i18n from 'i18n';
import requester from 'utils/requester';

export const KEY = 'USE_LOAD_FILTER';

const safeParse = (str = '') => {
  let parsed = {};
  try {
    parsed = JSON.parse(str);
  } catch {}

  return parsed;
};

const DEFAULT_FILTES = {
  SORTING_UI: {
    isMultiSelect: false,
    query: 'sort',
    values: [
      {
        id: 1,
        title: i18n.t('filtersPage.sortOptions.mostPopular'),
        description: 'views,desc',
      },
      {
        id: 2,
        title: i18n.t('filtersPage.sortOptions.imdb'),
        description: 'imdbRating,desc',
      },
      {
        id: 3,
        title: i18n.t('filtersPage.sortOptions.newer'),
        description: 'year,desc',
      },
      {
        id: 4,
        title: i18n.t('filtersPage.sortOptions.older'),
        description: 'year,asc',
      },
      {
        id: 5,
        title: i18n.t('filtersPage.sortOptions.recently'),
        description: 'uploadedOn,desc',
      },
    ],
  },
  CONTENT_TYPE_UI: {
    isMultiSelect: false,
    query: 'type',
    values: [],
  },
};

const apiCall = async () => {
  const result = cloneDeep(DEFAULT_FILTES);

  const filters = await requester({
    method: 'get',
    url: `${api.host}${api.endpoints.filters}`,
    params: { f_name: 'UI_CONFIG_V1' },
  });

  filters.content.forEach((list) => {
    const parsed = safeParse(list.description);

    parsed.display_filters?.forEach((filter) => {
      const name = Object.keys(filter)[0];

      if (!filter[name]) return;

      result[name] = {
        isMultiSelect: filter.isMultiSelect,
        query: filter.search_query.replace('=', ''),
        values: [],
      };
    });
  });

  const options = await requester({
    method: 'get',
    url: `${api.host}${api.endpoints.filters}`,
    params: {
      f_type: Object.keys(result)
        // SORTING_UI completely hardcoded on FE side
        .filter((name) => name !== 'SORTING_UI')
        .join(','),
      size: 1000,
      sort: 'position,asc',
    },
  });

  filter(options.content, ['is_active', true]).forEach((value) => {
    result[value.type].values.push(value);
  });

  return result;
};

const useLoadFilters = (options) => {
  return useQuery([KEY], () => apiCall(), { ...options });
};

export default useLoadFilters;
